import React from 'react';

function UserItem({ user, navigate, onRemove }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', padding: '4px 16px' }}>
      <img
        src={user.profile_url || '/assets/images/default_profile.png'}
        alt={user.username}
        style={{
          width: '40px',
          height: '40px',
          borderRadius: '50%',
          objectFit: 'cover',
          cursor: 'pointer',
        }}
        onClick={() => navigate(`/profile/${user.user_id}`)} // Navigate to user's profile
      />
      <p
        style={{ cursor: 'pointer' }}
        onClick={() => navigate(`/profile/${user.user_id}`)} // Navigate to user's profile
      >
        {user.username}
      </p>
      {onRemove && (
        <button onClick={onRemove} style={{ marginLeft: 'auto', cursor: 'pointer' }}>
          Remove
        </button>
      )}
    </div>
  );
}

export default UserItem;
